import * as React from "react";
import Footer from "./footer";
import Header from "./header";
import MobileMenu from "./mobile-menu";
import SearchBar from "./search-bar";
const queryString = require('query-string');
const NotificationSystem = require('react-notification-system');
import '@babel/polyfill';
export default class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.updateSearch = (searchText) => {
            this.setState({ searchText });
        };
        this.Search = () => {
            let searchQuery = queryString.stringify({ query: this.state.searchText });
            location.href = `/Products/Search?${searchQuery}`;
        };
        this.updateToggle = () => {
            this.setState({ toggleSearch: !this.state.toggleSearch });
        };
        this.updateMobileToggle = () => {
            this.setState({ toggleMobile: !this.state.toggleMobile });
        };
        this.state = {
            toggleSearch: false,
            toggleMobile: false,
            searchText: ""
        };
    }
    render() {
        return (React.createElement("div", { className: "Site" },
            React.createElement(NotificationSystem, { ref: "notificationSystem" }),
            React.createElement(Header, { route: this.props.route, toggle: this.updateToggle, toggleMobile: this.updateMobileToggle, mobile: this.state.toggleMobile }),
            React.createElement(MobileMenu, { toggleMobile: this.updateMobileToggle, toggle: this.state.toggleMobile }),
            React.createElement(SearchBar, { toggle: this.state.toggleSearch, searchText: this.state.searchText, updateSearch: this.updateSearch, Search: this.Search }),
            React.createElement("div", { className: "Content" }, this.props.children),
            React.createElement(Footer, null)));
    }
}
;
//# sourceMappingURL=layout.js.map